import Vue from 'vue';
import {Component, Watch} from 'vue-property-decorator'
import { eventBus } from '../../../main';
import { ITemplateMaintenance } from '../../../models/maintenance/template-maintenance.model';
import { MaintenanceService, TicketService } from '../../../services';

@Component({
  components: {
    'mr-autocomplete-selector': async () => import('../../block/block-maintenances/components/MRAutocompleteSelector/MRAutocompleteSelector.vue')
  }
})
class MaintenanceTemplate extends Vue {

  @Watch('pagination',{deep:true})
  handler(val)
  {
    this.loadTemplate()
  }

  @Watch('searchParams.char1')
  categorySelected(val)
  {
    if(val)
    {
      let subCat:any = this.Categories.find((item:any)=>item.id===val)
      subCat.level_2.map(item=>this.SubCategories.push({id:item.id,name:item.name}))
    }else
    {
      this.SubCategories = []
    }
  }


  totalTemplates: number
  templates:any[]
  loading: boolean
  pagination: any
  headers:any[]
  dialogDelete: boolean
  idTemplateToDelete:string
  searchParams:{q?:string, char1?:number, char2?:number,type?:[]}

  Categories:any[]
  SubCategories:any[]

  MaintenanceService:MaintenanceService
  charProblemAPI:TicketService


  constructor () {
    super()
    this.totalTemplates = 0
    this.templates = []
    this.loading = true
    this.pagination = {
      page: 1,
      rowsPerPage: 10
    }
    this.headers=[
      { text: 'Nom/Description', value: 'name', sortable: false, class: 'primaryDark--text body-2 font-weight-bold' },
      { text: 'Catégorie', value: 'maintenance_category', sortable: false, class: 'primaryDark--text body-2 font-weight-bold' },
      { text: 'Type', value: 'type', sortable: false, class: 'primaryDark--text body-2 font-weight-bold' },
      { text: 'Intervalle', value: 'interval', sortable: false, class: 'primaryDark--text body-2 font-weight-bold'},
      { text: 'Actions', value: 'name', sortable: false, class: 'primaryDark--text body-2 font-weight-bold' }
    ]
    this.dialogDelete = false,
    this.idTemplateToDelete = null
    this.searchParams = {q:null, char1:null, char2:null, type:[]}
    this.MaintenanceService = new MaintenanceService()
    this.charProblemAPI = new TicketService()
    this.Categories = []
    this.SubCategories = []
  }

  get lblSetting() {
    return {
      ...require('@/locales/maintenance').default,
      ...require('@/locales/validation-messages').default
    }
  }

  get coFilterType() {
    return [
      {value:'mandatory',name:'Obligatoire'},
      {value:'external',name:'Externe'},
      {value:'internal',name:'Interne'}
    ]
  }

  handleFilterChange()
  {
    this.loadTemplate()
  }

  resetFilter()
  {
    this.searchParams = {q:null, char1:null, char2:null, type:[]}
    this.loadTemplate()
  }

  mounted()
  {
    eventBus.$on('SEARCH_MAINTENANCE_TEMPLATE',key=>{
      this.searchParams.q = key
      this.loadTemplate()
    })

    eventBus.$on('RELOAD_MAINTENANCE_TEMPLATE',()=>{
      this.loadTemplate()
    })
    this.loadTemplate()

    // filters
    this.charProblemAPI.getCharacterProblems().then((response:any)=>{
      this.Categories = response.level_1
    })
  }

  beforeDistroy()
  {
    eventBus.$off('SEARCH_MAINTENANCE_TEMPLATE')
    eventBus.$off('RELOAD_MAINTENANCE_TEMPLATE')
  }

  loadTemplate()
  {
    this.getTemplates(this.searchParams).then((data:any)=>{
      this.totalTemplates = data.total
      this.templates = data.items
    })
  }

  editTemplate(template:ITemplateMaintenance)
  {
    eventBus.$emit('EDIT_TEMPLATE_MAINTENANCE',template)
  }

  truncate(text:string, length=100)
  {
    return text.length > length ? `${text.substring(0,length)} ...` : text
  }

  getTemplates(params:any)
  {
    this.loading = true
    return new Promise(async (resolve, reject) => {
      try {
        const { sortBy, descending, page, rowsPerPage } = this.pagination
        const limit = rowsPerPage
        const skip = (page-1)*rowsPerPage
        const templates = await this.MaintenanceService.getMaintenanceTemplates(
          {
            ...params,
            $limit:limit,
            $skip:skip
          }
        )
        let items = templates.data
        const total = templates.total
        this.loading = false
        resolve({items,total})
      } catch (error) {
        reject(error)
      }
    })
  }

  deleteTemplate()
  {
    this.MaintenanceService.deleteMaintenanceTemplate(this.idTemplateToDelete).then(data=>{
      console.log(data)
      this.dialogDelete = false
      this.loadTemplate()
    })
  }
}
export default MaintenanceTemplate



// WEBPACK FOOTER //
// ./src/containers/profile/maintenance-template/index.ts